import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'
import style from './styles/media_detail.module.scss'
import PhotosBlock from './components/PhotosBlock'
import MoreMedia from './components/MoreMedia'

const MediaDetail = (): React.ReactElement => {
  const page = usePage()
  const { object, global } = page.init_state
  const { config } = global

  const slicedDate =
    object.date_create !== '' ? object.date_create.slice(0, 10) : ''

  return (
    <Container>
      <BackLink href={`${config.news}#media`} title='К медиа' />
      {slicedDate !== ''
        ? (
          <span className={style.detail__date}>{slicedDate}</span>
          )
        : undefined}

      <Title type='h1' className={style.detail__title}>
        {object.title}
      </Title>

      {object.detail !== ''
        ? (
          <HtmlContent content={object.detail} className={style.detail__text} />
          )
        : undefined}

      <PhotosBlock object={object} />

      <MoreMedia />
    </Container>
  )
}

export default MediaDetail
